export default "__VITE_ASSET__DnWxBPDn__"